module.exports = {
    // index/default
    "BobTV, webcam chat for adults of Bob Voyeur": "BobTV, le Tchat Webcam pour Adultes de BobVoyeur | 18+ |",
    "Videochat rooms to exhibit on webcam for amateur libertines and voyeurs. Nudity and sex webcams are accepted on chat rooms.":
        "Exhibez vous en ligne entre amateurs et devant des voyeurs. La nudité et les rapports sexuels en cam sont autorisés sur nos salons de Visiochat depuis 2007.",

    // profile
    "%1, %2, %3, voyeur or exhibitionist on BobTV adult webcam chat": "%1 (%2) s’exhibe en cam sur le Tchat BobTV",
    "Member on adult video chat Bob TV" : "Consultez le profil de %1, %2 (%3) qui tchate en Webcam sur le Visiochat pour adultes | 18+ |",

    // profiles
    'List of members of the chat of exhib on cam': "Les membres exhibes et voyeurs du Chat Webcam BobTV.",
    'results for searching of members - BobTV': "résultats de recherche des membres - BobTV",
    'Search among bobTV members, exhibitionists, voyeurs, libertines or swingers': "Chattez en cam avec les amateurs exhibitionnistes et voyeurs de la communauté Bobvoyeur, le réseau des exhibes en ligne entre adultes.",

    // profile films
    'Amateur films of %1': "Les vidéos d’exhibe de %1 sur BobTV | Chat Webcam |",
    '%1 a enregistré des vidéos de charme et de sexe pour les voyeurs connectés sur les salons de Tchat de BobTV': '%1 a enregistré des vidéos de charme et de sexe pour les voyeurs connectés sur les salons de Tchat de BobTV.',

    // profile wishlist
    'La liste d’envies de %1 sur BobTV | Webcam Live |': "La liste d’envies de %1 sur BobTV | Webcam Live |",
    'Offrez un cadeau à %1 (%2) qui s’exhibe en Webcam et en direct sur les salons de discussion | 18+ |': 'Offrez un cadeau à %1 (%2) qui s’exhibe en Webcam et en direct sur les salons de discussion | 18+ |',

    // profile guestbook
    'Le livre d’or de %1 amateur en cam sur BobTV': "Le livre d’or de %1 amateur en cam sur BobTV",
    'Encouragez %1 (%2) qui participe aux discussions de cul et aux Shows Sexy sur les salles de Visio Chat': 'Encouragez %1 (%2) qui participe aux discussions de cul et aux Shows Sexy sur les salles de Visio Chat',

    // profile photos
    'Photos of %1': "Les photos de %1 sur le Visiochat BobTV |%2|",
    'profile photos description' : '%1 (%2) poste ses photos amateurs (érotiques et de sexe) sur son profil du Tchat Webcam. Venez mater !',

    // profile wall
    'Wall posts of %1': "Les posts de %1 sur le Mur de BobTV | Visiochat |",
    'The wall of BobTV, photos and videos posted by %1': "Matez les participations Photos et Vidéos de %1 (%2) sur le fil de discussion des salles de Chat de BobTV",

    // faq
    'Frequently Asked Questions (FAQ)': "La FAQ de BobTV - Aide en ligne du Tchat Webcam",
    'Help page to connect to BobTV Webcam Chat. Visio Chat of exhibitions and meetings between adults.': 'Consultez les “Questions & Réponses” pour lire les explications de connexion aux salons webcam de BobTV, le Chat pour adultes exhibitionnistes et voyeurs.',

    // amateur films
    'Amateur videos of bobbesies and bobbers': 'Les films amateurs des tchateurs de BobTV le Tchat Webcam',
    'Amateur videos by tag: %1': "Les vidéos d'exhibe de BobTV | %1 |",

    'Watch adult videos recorded by BobTV members showing off online in front of their webcams in the chat rooms': 'Regardez les vidéos pour adultes enregistrées par les membres de BobTV qui s’exhibent en ligne devant leur webcam sur les salles de discussions.',
    "Watch amateur films recorded on BobTV by bobsledders. The amateur exhibition in Live Video is on Bob Voyeur's Chat": "Matez les films amateurs enregistrés sur BobTV par les bobeuses et les bobeurs. L'exhibition amateur en Visio Live est sur le Tchat de Bob Voyeur.",

    // amateur film (id)

    "Amateur film by %1 on BobTV: %2": "Film amateur de %1 sur BobTV: %2",

    // wall
    'The wall  of BobTV, photos and videos posted by members': 'Le Mur de BobTV | Live Cam & Tchat 18+ |',
    'Check out the Video Clips recorded LIVE and the Sex Photos of the chatters who exhibit themselves in the BobTV shows': 'Consultez les Clips Vidéos enregistrés en LIVE et les Photos de Sexe des tchateuses et des tchateurs qui s’exhibent sur les salons de BobTV',

    //wall material

    'Post by %1 (%2) on the BobTV Wall': 'Post de %1 (%2) sur le Mur de BobTV',
    "Private photo or sex video posted by %1 on BobTV's Video Chat Wall." : 'Photo privée ou vidéo de sexe postée par %1 sur le Mur du Visio Chat de BobTV.',

    // wardrobe
    'Bobstore Wardrobe': 'Le Dressing de Bobstore, les cadeaux coquins de BobTV',
    'The Bobeuses reveal the sexy outfits from their Dressing Coquin. Lingerie, tights, stockings, sex toys, corsets, club dresses, disguises... offered by Bobeurs.': 'Les Bobeuses dévoilent les tenues sexy de leur Dressing Coquin. Lingerie, collants, bas, sextoys, corsets, robes de club, déguisements… offerts par des Bobeurs.',

    // wishlists
    "Les listes d’envies des membres du visiochat BobTV |18+|": "Les listes d’envies des membres du visiochat BobTV |18+|",
    "Un grand choix de cadeaux pour remercier les Bobeuses et les Bobeurs qui s’exhibent 24/24 et 7/7 en webcam (lingerie, sextoys, accessoires, bijoux…)": "Un grand choix de cadeaux pour remercier les Bobeuses et les Bobeurs qui s’exhibent 24/24 et 7/7 en webcam (lingerie, sextoys, accessoires, bijoux…)",

    // contact
    'Contact BobTV page': 'Contact et Support Technique | Tchat en Webcam BobTV',
    'Contact Bob for all matters relating to the webcam chat BobTV. Video Chat exhibitions and meetings between adults.': "Aide et Support en ligne de BobTV, adressez vos demandes et questions concernant l’enregistrement au Visiochat, votre compte d’utilisateur, votre abonnement.",

    // auth pages
    'Login to bobTV': 'Connexion à bobTV',
    'Registration at BobTV' : 'Inscription sur BobTV',
    'bobTV Webcam Chat free registration. Video Chat exhibitions and meetings between adults.' : 'Créez votre compte gratuit sur le Premier Tchat Webcam libertin. Rencontre, exhibition en cam pour des milliers d\'amateurs et de couples pratiquant l\'échangisme.',

    // cgu
    "The general conditions of use of Bob’s sites": 'Les conditions générales d’utilisation des sites de Bob',
    'Read the regulations, conditions of use and legal information of BobTV, Bobvoyeur and Bob4men (CGU).': 'Lisez le règlement, les conditions d’utilisation et les informations légales de BobTV, Bobvoyeur et Bob4men (CGU).'
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/meta.js